var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import * as React from "react";
// Our hook
export default function useDebounce(value, delay) {
    // State and setters for debounced value
    var _a = __read(React.useState(value), 2), debouncedValue = _a[0], setDebouncedValue = _a[1];
    React.useEffect(function () {
        // Set debouncedValue to value (passed in) after the specified delay
        var handler = setTimeout(function () {
            setDebouncedValue(value);
        }, delay);
        // Return a cleanup function that will be called every time ...
        // ... useEffect is re-called. useEffect will only be re-called ...
        // ... if value changes (see the inputs array below).
        // This is how we prevent debouncedValue from changing if value is ...
        // ... changed within the delay period. Timeout gets cleared and restarted.
        // To put it in context, if the user is typing within our app's ...
        // ... search box, we don't want the debouncedValue to update until ...
        // ... they've stopped typing for more than 500ms.
        return function () {
            clearTimeout(handler);
        };
    }, 
    // Only re-call effect if value changes
    // You could also add the "delay" var to inputs array if you ...
    // ... need to be able to change that dynamically.
    [value]);
    return debouncedValue;
}
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoidXNlRGVib3VuY2UuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyJ1c2VEZWJvdW5jZS50c3giXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7Ozs7Ozs7Ozs7Ozs7OztBQUFBLE9BQU8sS0FBSyxLQUFLLE1BQU0sT0FBTyxDQUFDO0FBRS9CLFdBQVc7QUFDWCxNQUFNLENBQUMsT0FBTyxVQUFVLFdBQVcsQ0FBQyxLQUFVLEVBQUUsS0FBYTtJQUMzRCx3Q0FBd0M7SUFDbEMsSUFBQSxLQUFBLE9BQXNDLEtBQUssQ0FBQyxRQUFRLENBQUMsS0FBSyxDQUFDLElBQUEsRUFBMUQsY0FBYyxRQUFBLEVBQUUsaUJBQWlCLFFBQXlCLENBQUM7SUFFbEUsS0FBSyxDQUFDLFNBQVMsQ0FDYjtRQUNFLG9FQUFvRTtRQUNwRSxJQUFNLE9BQU8sR0FBRyxVQUFVLENBQUM7WUFDekIsaUJBQWlCLENBQUMsS0FBSyxDQUFDLENBQUM7UUFDM0IsQ0FBQyxFQUFFLEtBQUssQ0FBQyxDQUFDO1FBRVYsK0RBQStEO1FBQy9ELG1FQUFtRTtRQUNuRSxxREFBcUQ7UUFDckQsc0VBQXNFO1FBQ3RFLDJFQUEyRTtRQUMzRSxtRUFBbUU7UUFDbkUsdUVBQXVFO1FBQ3ZFLGtEQUFrRDtRQUNsRCxPQUFPO1lBQ0wsWUFBWSxDQUFDLE9BQU8sQ0FBQyxDQUFDO1FBQ3hCLENBQUMsQ0FBQztJQUNKLENBQUM7SUFDRCx1Q0FBdUM7SUFDdkMsZ0VBQWdFO0lBQ2hFLGtEQUFrRDtJQUNsRCxDQUFDLEtBQUssQ0FBQyxDQUNSLENBQUM7SUFFRixPQUFPLGNBQWMsQ0FBQztBQUN4QixDQUFDIn0=